import { useValue } from "@legendapp/state/react";
import { Icon } from "@repo/ui/components/icon";
import { ShortcutKbd } from "@repo/ui/lib/actions/shortcut-kbd";
import { Tooltip, TooltipContent, TooltipTrigger } from "@repo/ui/tooltip";
import { Button } from "@repo/ui/ui/button";
import { useRouterState } from "@tanstack/react-router";

import { chat$ } from "~/stores/chat";
import { isChatPaneRoute } from "./chat/chat-route";

/**
 * Shared toggle for the global AI chat pane. Rendered at the end of page
 * headers so it sits after page-specific actions. Hidden on routes where the
 * AI chat is not accessible.
 */
export const AiPaneToggle = () => {
  const isOpen = useValue(chat$.isOpen);

  const isChatRoute = useRouterState({
    select: (s) => isChatPaneRoute(s.location.pathname),
  });

  if (!isChatRoute) return null;

  return (
    <Tooltip>
      <TooltipTrigger
        render={(props) => (
          <Button
            {...props}
            variant="ghost"
            size="icon"
            className="shrink-0 text-muted-foreground"
            onClick={chat$.isOpen.toggle}
          >
            <Icon name={isOpen ? "comment-fill" : "comment"} />
          </Button>
        )}
      />
      <TooltipContent className="flex items-center gap-2">
        Toggle AI pane
        <ShortcutKbd shortcutId="toggle-right-pane" />
      </TooltipContent>
    </Tooltip>
  );
};
